import { Polyline } from "./elements/Polyline"


interface MapPolylineProps {
    paths: any[],
    strokeColor?: string,
}
export const MapPolyline = ({
    paths,
    strokeColor = "#FF0000",
}: MapPolylineProps) => {
    return (
        <Polyline
            path={paths}
            strokeWeight={paths.length === 1 ? 10 : 2}
            strokeColor={strokeColor}
            geodesic={true}
            strokeOpacity={1}
        />
    )
}
